import { Box, TextareaAutosize, Typography, styled } from '@mui/material';
import Background from '../../assets/icons/login/LoginBackground.svg';
import BackgroundMobile from '../../assets/icons/login/LoginBackgroundMobile.svg';

const BACKDROP_HEIGHT = '100%';

export const PageShell = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  backgroundColor: '#fafafa',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '24px 16px 48px',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'fixed',
    inset: 0,
    zIndex: 0,
    pointerEvents: 'none',
    backgroundImage: `url(${Background})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: `auto ${BACKDROP_HEIGHT}`,
    backgroundPosition: 'left top',
    [theme.breakpoints.down(1095)]: {
      backgroundImage: `url(${BackgroundMobile})`,
      backgroundSize: `auto ${BACKDROP_HEIGHT}`,
      backgroundPosition: 'left top',
    },
  },
  // Lifts content above the artwork. Position only — flex layout is unaffected.
  '& > *': {
    position: 'relative',
    zIndex: 1,
  },
  [theme.breakpoints.down(600)]: {
    padding: '16px 12px 32px',
  },
}));

export const ContentColumn = styled(Box)({
  width: '100%',
  maxWidth: '640px',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});

export const FormCard = styled(Box)({
  width: '100%',
  backgroundColor: '#fff',
  borderRadius: '8px',
  boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.05)',
  padding: '32px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
});

export const PageTitle = styled(Typography)(({ theme }) => ({
  fontSize: '20px',
  fontWeight: 600,
  color: theme.palette.secondary.contrastText,
}));

export const PageIntro = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.secondary.main,
}));

export const MotivationTextArea = styled(TextareaAutosize, {
  shouldForwardProp: prop => prop !== 'hasError',
})<{ hasError?: boolean }>(({ theme, hasError }) => ({
  width: '100%',
  padding: '14px',
  border: '1px solid',
  borderColor: hasError ? theme.palette.error.main : 'rgba(0, 0, 0, 0.23)',
  fontSize: '14px',
  lineHeight: '20px',
  color: '#5F6161',
  borderRadius: '4px',
  fontFamily: 'Montserrat,sans-serif',
  resize: 'vertical',
  '&::placeholder': {
    color: theme.palette.secondary.dark,
    opacity: 0.42,
  },
  '&:not([aria-hidden])': {
    minHeight: '130px',
  },
  '&:focus': {
    outline: '2px solid #008C15',
  },
}));

export const FieldHint = styled('p')(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.secondary.main,
  margin: '2px 0 0 0',
}));

export const FieldErrorText = styled('p')(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.error.main,
  margin: '3px 0 0 0',
}));

export const CharacterCounter = styled(Box, {
  shouldForwardProp: prop => prop !== 'isAtLimit',
})<{ isAtLimit?: boolean }>(({ theme, isAtLimit }) => ({
  fontSize: '12px',
  textAlign: 'right',
  color: isAtLimit ? theme.palette.error.main : theme.palette.secondary.main,
}));

export const FieldRow = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  width: '100%',
  '& .MuiTextField-root': {
    height: 'auto',
    minHeight: '49px',
  },
});
